import * as Sentry from "@sentry/react";

const DSN =
  "https://17ff40e2c78c9f58bf7c23d2345d2f8b@o4504120422039552.ingest.us.sentry.io/4511308544540672";

export function initSentry(): void {
  if (!import.meta.env.PROD) return;

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,
  });
}
